import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  EVOLUTION_PAGE,
  OVERVIEW_PAGE,
} from 'src/app/my-bill/config/my-bill.constants';

@Component({
  selector: 'my-bill-evolution-tab',
  templateUrl: './my-bill-evolution-tab.component.html',
  standalone: false,
})
export class MyBillEvolutionTabComponent {
  @Input() isEvolutionTabActive: boolean;

  constructor(private router: Router) {}

  onOverviewClick() {
    this.router.navigate([OVERVIEW_PAGE]);
  }

  onEvolutionClick() {
    this.router.navigate([EVOLUTION_PAGE]);
  }
}
